export default __webpack_public_path__ + "static/media/Ania.a5d4b88f.jpg";